export default "__VITE_ASSET__CQ3QPC8u__"